import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

export const ProductCard = ({ product }) => (
  <Link
    to={`/produit/${product.slug}`}
    data-testid={`product-card-${product.slug}`}
    className="group block card-ae overflow-hidden transition-transform duration-300 hover:-translate-y-1"
  >
    <div className="relative aspect-[4/3] overflow-hidden bg-cream-dark">
      <img
        src={product.image}
        alt={product.name}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
      />
      <button
        type="button"
        aria-label="Ajouter aux favoris"
        data-testid={`product-favorite-${product.slug}`}
        onClick={(e) => e.preventDefault()}
        className="absolute right-3 top-3 rounded-full bg-white/90 p-2 text-deepgreen shadow-sm transition-colors hover:text-gold"
      >
        <Heart className="h-4 w-4" />
      </button>
      {product.test && (
        <span className="absolute left-3 top-3 rounded-full bg-gold-light/95 px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wider text-deepgreen">
          TEST
        </span>
      )}
    </div>
    <div className="p-5">
      <h3 className="font-heading text-lg text-deepgreen">{product.name}</h3>
      <p className="mt-1 text-sm text-muted-foreground">
        <span className="text-base font-semibold text-deepgreen">{product.price.toFixed(2)} €</span> TTC / weekend
      </p>
    </div>
  </Link>
);
